import { NgModule } from '@angular/core';

// modules (angular)
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// modules
import { SharedModule } from '@shared/shared.module';

// components
import { ContactsComponent } from './components/contacts/contacts.component';
import { FooterComponent } from './footer.component';
import { LinksComponent } from './components/links/links.component';
import { NewsletterComponent } from './components/newsletter/newsletter.component';
import { TotopComponent } from './components/totop/totop.component';
import { ApplyForVendorComponent } from './components/apply-for-vendor/apply-for-vendor.component';
import { VendorFormComponent } from './components/apply-for-vendor/vendor-form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { VendorFormSuccessComponent } from './components/apply-for-vendor/vendor-form-success/vendor-form-success.component';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { PlanDetailsComponent } from './components/plan-details/plan-details.component';
import { CompleteVendorRegisterComponent } from './components/complete-vendor-register/complete-vendor-register.component';
import { QuotationRequestsModule } from '../quotation-requests/quotation-requests.module';

@NgModule({
    imports: [
        // modules (angular)
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        FlexLayoutModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatDividerModule,
        MatIconModule,
        // modules
        SharedModule,
        ContactsComponent,
        FooterComponent,
        LinksComponent,
        NewsletterComponent,
        TotopComponent,
        ApplyForVendorComponent,
        VendorFormComponent,
        VendorFormSuccessComponent,
        PlanDetailsComponent,
        CompleteVendorRegisterComponent
    ],
    exports: [
        FooterComponent,
        ApplyForVendorComponent,
        PlanDetailsComponent,
        VendorFormComponent,
        CompleteVendorRegisterComponent
    ]
})
export class FooterModule { }
